'use client';

import { useTranslations } from 'next-intl';
import { ComponentProps } from 'react';
import { Coupon } from '@/features/coupons/api/coupons';
import { cn } from '@/shared/lib/cn';
import { useGetLocalizedValue } from '@/shared/lib/hooks/useGetLocalizedValue';
import { Card } from '@/shared/ui/card';
import { Icon } from '@/shared/ui/icon';
import { Layout } from '@/shared/ui/layout';
import { Media } from '@/shared/ui/media';
import { ModalService } from '@/shared/ui/modal/ModalService';
import './my-coupons-modal.scss';

type Props = ComponentProps<typeof Layout> & {
    coupon: Coupon;
};
export const MyCouponsModalCouponItem = ({ coupon, className, media, ...props }: Props) => {
    const t = useTranslations();
    const getLocalizedValue = useGetLocalizedValue();
    const formattedDate = new Date(coupon.validUntil).toLocaleDateString(undefined, {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
    });
    const title = getLocalizedValue(coupon.title);

    const handleShowCoupon = () => {
        ModalService.showPrefab('CouponModal', { coupon });
    };

    return (
        <Layout
            element={Card}
            shadow
            className={cn('my-coupons-modal__coupon', className)}
            media={media}
            {...props}
            onClick={handleShowCoupon}
            as="button"
        >
            <div className="my-coupons-modal__coupon-media">
                <Media
                    data={{ alt: title, url: coupon.imageUrl, unoptimized: true }}
                    data-testid="my-coupons-modal-coupon-media"
                />
            </div>
            <div className="my-coupons-modal__coupon-content">
                <p className="my-coupons-modal__coupon-name" data-testid="my-coupons-modal-coupon-name">
                    {title}
                </p>
                <div className="my-coupons-modal__coupon-details">
                    <div className="my-coupons-modal__coupon-detail">
                        <span className="my-coupons-modal__coupon-label">
                            {t('MY_COUPONS_MODAL.COUPON_CARD.CODE')}
                        </span>
                        <span
                            className="my-coupons-modal__coupon-value"
                            data-testid="my-coupons-modal-coupon-code"
                        >
                            {coupon.code}
                        </span>
                    </div>
                    <div className="my-coupons-modal__coupon-detail">
                        <span className="my-coupons-modal__coupon-label">
                            {t('MY_COUPONS_MODAL.COUPON_CARD.VALID')}
                        </span>
                        <span data-testid="my-coupons-modal-coupon-valid-until">
                            {t('MY_COUPONS_MODAL.COUPON_CARD.UNTIL', { date: formattedDate })}
                        </span>
                    </div>
                </div>
            </div>
            <Icon name="chevron-right" className="my-coupons-modal__coupon-chevron" />
        </Layout>
    );
};
